import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AttributesPage, attributesQueryOptions } from '@/features/dictionary';

/** The whole dictionary is loaded; `q` filters it by label on the client. */
const attributeListSearchSchema = z.object({ q: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/attributes/')({
  staticData: { tours: ['dictionary.attributes'] },
  validateSearch: attributeListSearchSchema,
  loader: ({ context }) =>
    context.queryClient
      .query({ ...attributesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: AttributesPage,
});
